import { render, staticRenderFns } from "./FootBar.vue?vue&type=template&id=091385d3&scoped=true"
import script from "./FootBar.vue?vue&type=script&lang=js"
export * from "./FootBar.vue?vue&type=script&lang=js"
import style0 from "./FootBar.vue?vue&type=style&index=0&id=091385d3&prod&lang=css"
import style1 from "./FootBar.vue?vue&type=style&index=1&id=091385d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091385d3",
  null
  
)

export default component.exports